import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import NavContext from "../../context/NavContext";
import { CabineProvider } from "../../context/CabineContext";
import CalibrationRequestForm from "../../components/CalibrationRequest/CalibrationRequestForm";
import styles from "./CalibrationRequestPage.module.scss";

const CalibrationRequestPage = () => {
  const navigate = useNavigate();
  const { ownerProfile, ownerId } = useContext(NavContext);

  const handleClose = () => {
    navigate("/private/dashboard");
  };

  return (
    <motion.div
      className={styles.page}
      variants={animatePage}
      exit="exit"
      initial="hidden"
      animate="visible"
    >
      <CabineProvider>
        <CalibrationRequestForm
          ownerProfile={ownerProfile}
          ownerId={ownerId}
          onClose={handleClose}
        />
      </CabineProvider>
    </motion.div>
  );
};

export default CalibrationRequestPage;
